import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { PERIODOS_RESUMO_ACESSOS, PeriodoResumoAcessos } from "@/types/pessoa-acesso.type";

export function PeriodoAcessoSelect({
  value,
  onChange,
}: {
  value: PeriodoResumoAcessos;
  onChange: (dias: PeriodoResumoAcessos) => void;
}) {
  return (
    <Select
      value={String(value)}
      onValueChange={(v) => onChange(Number(v) as PeriodoResumoAcessos)}
    >
      <SelectTrigger className="w-[160px]" aria-label="Período dos acessos">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {PERIODOS_RESUMO_ACESSOS.map((periodo) => (
          <SelectItem key={periodo} value={String(periodo)}>
            Últimos {periodo} dias
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
